(function(angular){
	'use strict';

	angular
		.module('incomeReitHistoricalDividendsChartModule', [
			'highChartsModule'
		]);
})(window.angular);